import { useAuth } from "api/hooks/useAuth";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const isAuthenticated = useAuth(); // Replace with your auth hook/context
  return isAuthenticated ? children : <Navigate to="/auth" replace />;
};

export default PrivateRoute;
